import useHasHydrated from "@qoohoo/common/hooks/useHasHydrated";
import {
  getTemporalLabel,
  getRecurringChannelStartDate,
} from "@qoohoo/common/helpers/channel";

const TagAndPerks = ({ channelDetails }) => {
  const hasMultiplePlans = channelDetails.plans?.length > 1;
  const basePlan = channelDetails.plans?.find((plan) => plan.is_base_plan);
  const isRecurring = channelDetails.type === "recurring";

  const channelScheduleDetails = getTemporalLabel({
    channelType: channelDetails.type,
    start_date: channelDetails.meta_info.scheduled_start_date,
    end_date: channelDetails.meta_info.scheduled_end_date,
    planDetails: {
      planType: channelDetails.plans?.[0]?.plan_type,
      interval: channelDetails.plans?.[0]?.interval,
      duration: channelDetails.plans?.[0]?.duration,
    },
  });

  const recurringChannelStartDateLabel =
    channelDetails?.type === "recurring" &&
    getRecurringChannelStartDate(channelDetails.meta_info.scheduled_start_date);

  return (
    <>
      <ul className="self-start w-full lg:w-full md:max-w-[475px] lg:max-w-none flex md:block p-6 md:pr-0 md:p-0 md:w-max mt-6 sm:mt-9 md:mt-5 md:space-y-4 text-sm text-center md:text-left lg:pr-0 lg:py-0 children:flex children:flex-shrink-0 children:flex-col md:children:flex-row children:items-center tab:justify-center md:justify-start gap-5 md:gap-0 md:children:space-x-3 lg:bg-transparent bg-[#22272B] rounded-lg font-nunito overflow-auto scrollbar-hide">
        {useHasHydrated() && channelScheduleDetails && (
          <li>
            <img src="/assets/icons/join-calendar.svg" alt="calendar icon" />
            <span className="mt-2 font-semibold tracking-tight">
              {channelScheduleDetails}
              {recurringChannelStartDateLabel && (
                <>
                  {" "}
                  <span className="text-[9px]">•</span>{" "}
                  {recurringChannelStartDateLabel}
                </>
              )}
            </span>
          </li>
        )}
        {hasMultiplePlans && (
          <li>
            <img
              src="/assets/icons/multiple-plan.svg"
              alt="multiple plan icon"
            />
            <span className="mt-2" >Multiple plans available</span>
          </li>
        )}
        {channelDetails.is_live_interaction_available && (
          <li>
            <img src="/assets/icons/join-chat.svg" alt="chat icon" />
            <span className="mt-2">Live interaction</span>
          </li>
        )}
        <li>
          <img src="/assets/icons/join-ticket.svg" alt="ticket icon" />
          <span className="mt-2">Exclusive communities</span>
        </li>
        <li>
          <img src="/assets/icons/join-people.svg" alt="people icon" />
          <span className="mt-2">Like-minded networking</span>
        </li>
      </ul>
    </>
  );
};

export default TagAndPerks;
